import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppRouter } from "./AppRouter";
import { Modal } from "./components/Modal";

import { preloadQueue } from "./utils/preloadImages";

function App() {
  const { modal } = useSelector((state: any) => state);

  useEffect(() => {
    preloadQueue.start();
  }, []);

  return (
    <>
      <AppRouter />
      {modal.open && <Modal />}
    </>
  );
}

export default App;
